import { useMutation } from "@tanstack/react-query"

import { useSendMailModalStore } from "./useSendMailModalStore"
import { QUERY_KEYS } from "../../../../../constants"
import { useUserQuery } from "../../../../../networking/queries"
import { sendMail } from "../../../../../networking/user"
import { queryClient } from "../../../../../util/queryClient"

const useSendMailMutation = () => {
  const { user } = useUserQuery()

  const {
    selectedChildId,
    message,
    selectedGift,
    imageFile,
    audioFile,
    onClose: onCloseSendMailModal,
  } = useSendMailModalStore()

  return useMutation({
    mutationFn: () =>
      sendMail({
        senderId: user?.id as number,
        receiverId: selectedChildId,
        body: message,
        itemGiftId: selectedGift?.id,
        photoFile: imageFile || undefined,
        audioFile: audioFile || undefined,
      }),
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries([QUERY_KEYS.FAMILY_MAIL]),
        queryClient.invalidateQueries([QUERY_KEYS.INVENTORY]),
        queryClient.invalidateQueries([QUERY_KEYS.RECENT_MAIL]),
      ])
      onCloseSendMailModal()
    },
  })
}

export default useSendMailMutation
